import React, { useEffect, useState } from 'react';
import SelectSingle from './SelectSingle';
import Progress from './Progress';
import { useSnackbar } from 'notistack';
import { TSession } from '../Sessions/Sessions';
import sessionsService from '../../services/sessions';

interface Props {
  value: TSession | undefined;
  onChange: (TSession: TSession | undefined) => void;
}

const SelectSingleTSession: React.FunctionComponent<Props> = (props) => {
  const [sessions, setSessions] = useState<Array<TSession>>();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    let cancelled = false;
    sessionsService
      .getSessions({ offset: 0, limit: 1000, orderBy: 'creationTime', sortOrder: 'Ascending' })
      .then((result) => {
        if (!cancelled) setSessions(result?.items ?? []);
      })
      .catch(() => {
        if (!cancelled) {
          setSessions([]);
          enqueueSnackbar('Failed to load sessions', { variant: 'error', autoHideDuration: 3000 });
        }
      });
    return () => {
      cancelled = true;
    };
  }, [enqueueSnackbar]);

  if (!sessions) {
    return <Progress />;
  }

  const selected = sessions.find((p) => p && p.id === (props.value && props.value.id));

  return (
    <SelectSingle<TSession>
      selected={selected}
      onChange={props.onChange}
      data={sessions}
      isClearable={true}
      label="Session"
      placeholder="Select Session"
      optionValue={(option) => String(option.id)}
      optionLabel={(option) => String(option.id)}
    />
  );
};

export default SelectSingleTSession;
